var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcsA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1420_38374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 8.75C5.25 7.1001 5.25 6.27515 5.76256 5.76256C6.27515 5.25 7.1001 5.25 8.75 5.25H9.33333C10.9832 5.25 11.8082 5.25 12.3208 5.76256C12.8333 6.27515 12.8333 7.1001 12.8333 8.75V9.33333C12.8333 10.9832 12.8333 11.8082 12.3208 12.3208C11.8082 12.8333 10.9832 12.8333 9.33333 12.8333H8.75C7.1001 12.8333 6.27515 12.8333 5.76256 12.3208C5.25 11.8082 5.25 10.9832 5.25 9.33333V8.75Z",
    stroke: "#3D4AF5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91645 5.25002C9.91505 3.52505 9.88897 2.63156 9.38684 2.01977C9.28989 1.90162 9.18156 1.79329 9.06344 1.69633C8.41804 1.16669 7.45921 1.16669 5.5415 1.16669C3.62381 1.16669 2.66496 1.16669 2.01959 1.69633C1.90144 1.79329 1.79311 1.90162 1.69615 2.01977C1.1665 2.66514 1.1665 3.62399 1.1665 5.54169C1.1665 7.4594 1.1665 8.41822 1.69615 9.06362C1.7931 9.18175 1.90144 9.29007 2.01959 9.38702C2.63138 9.88915 3.52487 9.91523 5.24984 9.91663",
    stroke: "#3D4AF5",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1420_38374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcsA);
export default __webpack_public_path__ + "static/media/copy_ics_a.15fcec3de15d765691acc67b5f8531ec.svg";
export { ForwardRef as ReactComponent };